import get from '../../../common/services/api/get';

export default function getIngestionStatus() {
    return get('/ui/ingestion/status');
}
